<div *ngIf="entity" class="previewCard unselectable" (click)="goToItemDetails()">
  <!-- image -->
  <div class="list-item-image" [style.background-image]="entity.mainImage ? entity.mainImage.safe : ''">
    <!-- video -->
    <!-- <iframe *ngIf="entity.videourlSafe" [src]="entity.videourlSafe" frameborder="0" allow="fullscreen" allowfullscreen style="height: 100%; width: 100%;"></iframe> -->

    <!-- triangle -->
    <div class="triangle">
      <span [hidden]="entity.price_mode == 'PRICE_ON_REQUEST' && entity.price == '0,00'"
        >{{ entity.price | moneyInsertThousandSigns }}€&nbsp;</span
      >
      <span>{{ entity.price_mode | enumtranslate }}</span>
    </div>
  </div>

  <!-- content -->
  <div fxLayout="column" fxLayoutGap="10px" class="content">
    <div fxFlex="grow" fxLayout="column" class="overflow-hidden" style="position: relative">
      <div class="title">
        <span class="type">{{ entity.advertisement_type == 'OFFER' ? 'Biete' : 'Suche' }}:</span> {{ entity.title }}
      </div>
      <div class="teaser">
        <span *ngIf="entity.zip">{{ entity.zip }} </span>
        <span *ngIf="entity.city">{{ entity.city }}</span>
      </div>
    </div>

    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <views-display fxFlex="noshrink" [views]="entity.count_views"></views-display>
      <div fxFlex="grow"></div>
      <button fxFlex="noshrink" class="transparent-orange-button">mehr erfahren</button>
    </div>
  </div>
</div>
